export * from './wordpress.provider';